module.exports = __webpack_public_path__ + "img/screenshot_new103.4ffa9dc8.png";